(function(){
  if (window.__kasMobileToastLoaded) { return; }
  window.__kasMobileToastLoaded = true;
  var DEBUG = false; // disable debug logs
  function log(){ if(!DEBUG) return; try{ var a=[].slice.call(arguments); a.unshift('[ATC-Toast]'); console.log.apply(console, a); }catch(_){} }
  var DISMISS_MS = (window.kasAtcToast && Number(window.kasAtcToast.durationMs)) || 2500;
  var MOBILE_MAX = 750;
  function isMobile(){ var w = window.innerWidth; var r = w < MOBILE_MAX; log('isMobile?', r, 'width=', w); return r; }
  function matches(el, sel){ var p = Element.prototype; var f = p.matches || p.webkitMatchesSelector || p.mozMatchesSelector || p.msMatchesSelector; return f.call(el, sel); }
  function closest(el, sel){ if(!el) return null; if(el.closest) return el.closest(sel); while(el && el.nodeType===1){ if(matches(el, sel)) return el; el = el.parentElement || el.parentNode; } return null; }
  function escapeHtml(s){ if(typeof s!=='string') return s; return s.replace(/[&<>"']/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;','\'':'&#39;'}[c];}); }
  function createToast(message){
    log('show toast', message);
    try{ var existing=document.querySelector('.c-collection-inline-toast'); if(existing) existing.parentNode.removeChild(existing);}catch(e){}
    var wrap=document.createElement('div');
    wrap.className='c-collection-inline-toast';
    // Inline fallback styles in case stylesheet fails to load
    wrap.style.position='fixed';
    wrap.style.left='50%';
    wrap.style.bottom='16px';
    wrap.style.transform='translateX(-50%)';
    wrap.style.background='rgba(25,25,25,.95)';
    wrap.style.color='#fff';
    wrap.style.borderRadius='8px';
    wrap.style.zIndex='2147483647';
    wrap.style.boxShadow='0 6px 20px rgba(0,0,0,.18)';
    wrap.style.maxWidth='calc(100% - 32px)';
    wrap.style.pointerEvents='none';
    wrap.style.opacity='1';
    wrap.style.visibility='visible';
    try{ wrap.style.setProperty('display','block','important'); wrap.style.setProperty('opacity','1','important'); wrap.style.setProperty('visibility','visible','important'); }catch(_){ }
    // Default bottom placement; we will reposition under header after mount
    try{ wrap.style.bottom='calc(16px + env(safe-area-inset-bottom))'; }catch(_){ wrap.style.bottom='16px'; }
    wrap.setAttribute('role','status');
    wrap.setAttribute('aria-live','polite');
    wrap.innerHTML='\n      <div class="c-collection-inline-toast__inner" style="display:flex;align-items:center;gap:.75rem;padding:.75rem 1rem;pointer-events:auto">\n        <span class="c-collection-inline-toast__text" style="font-size:.875rem;line-height:1.2;flex:1 1 auto">'+escapeHtml(message)+'</span>\n        <button type="button" class="c-collection-inline-toast__close" data-collection-inline-toast-close aria-label="Close" style="appearance:none;border:0;background:transparent;color:#fff;font-size:1.125rem;line-height:1;padding:.25rem;cursor:pointer">×</button>\n      </div>\n    ';
    document.body.appendChild(wrap);
    // Reposition under header to guarantee visibility
    try{
      var header = document.querySelector('[data-header-container]');
      var headerH = header ? header.getBoundingClientRect().height : 0;
      var topOffset = Math.max(12, Math.min(120, Math.round(headerH + 12)));
      wrap.style.bottom = 'auto';
      try{ wrap.style.top = 'calc(' + topOffset + 'px + env(safe-area-inset-top))'; }
      catch(_){ wrap.style.top = topOffset + 'px'; }
    }catch(_){ }
    try{ var rect = wrap.getBoundingClientRect(); log('toast rect', rect); }catch(_){ }
    // Attempt to ensure visibility; if offscreen, move to top
    setTimeout(function(){
      try{
        var r = wrap.getBoundingClientRect();
        var offscreen = (r.height === 0) || (r.bottom <= 0) || (r.top >= window.innerHeight);
        if(offscreen){
          log('toast offscreen, moving to top');
          wrap.style.bottom = 'auto';
          wrap.style.top = '16px';
          var r2 = wrap.getBoundingClientRect();
          log('toast rect after move', r2);
          if(r2.height === 0){
            log('toast still not visible, using alert fallback');
            try{ alert(message); }catch(_){}
          }
        }
      }catch(err){ log('ensure visible error', err); }
    }, 20);
    var t=setTimeout(function(){ if(wrap && wrap.parentNode){ wrap.parentNode.removeChild(wrap); } }, DISMISS_MS);
    wrap.addEventListener('click', function(e){ var btn=closest(e.target,'[data-collection-inline-toast-close]'); if(!btn) return; e.preventDefault(); if(wrap && wrap.parentNode){ wrap.parentNode.removeChild(wrap); } clearTimeout(t); }, true);
  }
  function updateCartCount(){
    try{ fetch('/cart.js', {credentials:'same-origin'}).then(function(r){return r.json()}).then(function(cart){
      var els = document.querySelectorAll('[data-cart-counter]');
      var val = cart && cart.item_count > 0 ? String(cart.item_count) : '';
      els.forEach(function(el){ el.textContent = val; });
      log('cart count updated', cart && cart.item_count, 'elements=', els.length);
      try{ var evt = new CustomEvent('kas:cart:count-updated', { detail: { count: cart && cart.item_count } }); document.dispatchEvent(evt); }catch(_){ }
    }); }catch(e){ log('cart count error', e); }
  }
  function addVariantToCart(variantId){
    // Use classic form-encoded payload for maximum compatibility
    var body = 'id=' + encodeURIComponent(String(variantId)) + '&quantity=1';
    return fetch('/cart/add.js', {
      method:'POST',
      headers:{'Content-Type':'application/x-www-form-urlencoded; charset=UTF-8','Accept':'application/json'},
      credentials:'same-origin',
      body: body
    }).then(function(r){ if(!r.ok){ return r.json().then(function(j){ throw j; }); } return r.json(); });
  }
  function fetchCartState(){
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function(r){ return r.json(); });
  }
  function setCartState(cart){
    try{ window.Cart = window.Cart || {}; window.Cart.data = cart; log('cart state synced', cart && cart.item_count); }catch(e){ log('cart state sync error', e); }
  }
  function findVariantIdForTarget(target){
    // Collection thumbnail button
    var container = closest(target, '[data-product-thumbnail]');
    if(container && container.getAttribute('data-variant-id')){
      return container.getAttribute('data-variant-id');
    }
    if(target && target.getAttribute && target.getAttribute('data-variant-id')){
      return target.getAttribute('data-variant-id');
    }
    if(target && target.dataset && target.dataset.variantId){
      return target.dataset.variantId;
    }
    // Product page form
    var form = closest(target, 'form');
    if(!form){ form = document.querySelector('[data-product-template-add-to-cart] form, form[action\="/cart/add"]'); }
    if(form){
      var idEl = form.querySelector('input[name="id"], select[name="id"]');
      if(idEl && idEl.value){ return idEl.value; }
    }
    return null;
  }
  function findProductTitleForTarget(target){
    // From collection JSON blob
    var container = closest(target, '[data-product-thumbnail]');
    if(container){
      try{ var jsonEl = container.querySelector('[data-product-json]'); if(jsonEl){ var p = JSON.parse(jsonEl.textContent || jsonEl.innerHTML || '{}'); if(p && p.title) return p.title; } }catch(err){}
    }
    // From product page title
    var titleEl = document.querySelector('[data-product-title], .c-product-template__title, [itemprop="name"]');
    if(titleEl && titleEl.textContent){ return titleEl.textContent.trim(); }
    return 'Item';
  }
  var CLICK_SELECTORS = ['[data-product-thumbnail-add-to-cart-button]', '[data-add-to-cart-button]'];
  log('mobile-atc-toast loaded');
  document.addEventListener('click', function(e){
    log('click captured', e.target && e.target.tagName, e.target && e.target.className);
    var target = e.target;
    var btn = null;
    for(var i=0;i<CLICK_SELECTORS.length;i++){ var cand = closest(target, CLICK_SELECTORS[i]); if(cand){ btn = cand; break; } }
    if(!btn){ return; }
    log('candidate button?', !!btn, btn && btn.getAttribute('data-variant-id'));
    if(!isMobile()){ return; } // desktop unchanged
    var variantId = findVariantIdForTarget(btn);
    log('resolved variantId', variantId);
    if(!variantId){ return; } // let default handlers proceed if we can't resolve
    e.preventDefault(); e.stopPropagation(); if(e.stopImmediatePropagation) e.stopImmediatePropagation();
    try {
      var evtPend = new CustomEvent('onCartPending'); document.dispatchEvent(evtPend);
      if(window.jQuery){ window.jQuery(document).trigger('onCartPending'); }
    } catch(ex) { log('dispatch onCartPending error', ex); }
    try{ btn.setAttribute('disabled','disabled'); }catch(_){ }
    var productTitle = findProductTitleForTarget(btn);
    log('posting to /cart/add.js');
    addVariantToCart(variantId)
      .then(function(resp){
        log('add success', resp);
        createToast(productTitle + ' was added to cart');
        // Sync cart state then notify listeners to refresh drawer
        fetchCartState()
          .then(function(cart){ setCartState(cart); updateCartCount(); })
          .finally(function(){
            try {
              var evt = new CustomEvent('onCartFinished');
              document.dispatchEvent(evt);
              if (window.jQuery) { window.jQuery(document).trigger('onCartFinished'); }
            } catch (ex) { log('dispatch onCartFinished error', ex); }
          });
      })
      .catch(function(err){ log('add error', err); var msg = (err && err.description) ? err.description : 'Unable to add to cart'; try{ alert(msg); }catch(_){ } })
      .finally(function(){ try{ btn.removeAttribute('disabled'); }catch(_){ } });
    // prevent cart drawer auto open by setting a short-lived flag
    window.__kas_suppress_cart_open = true; setTimeout(function(){ window.__kas_suppress_cart_open = false; }, 1500);
  }, true);
  // Guard against any programmatic cart drawer opens immediately after add on mobile
  document.addEventListener('click', function(e){
    var tgl = closest(e.target, '[data-cart-drawer-toggle]');
    if(!tgl) return;
    if(isMobile() && window.__kas_suppress_cart_open){ log('suppressing cart drawer open'); e.preventDefault(); e.stopPropagation(); if(e.stopImmediatePropagation) e.stopImmediatePropagation(); }
  }, true);
})();


